import { useState } from 'react';
import { type PDPModalProps } from '@hungryroot/rdp';

import { usePdpFooter } from '../../PDP/usePdpFooter';

export function usePdpModal({ onClose }: { onClose: () => void }) {
  const [selectedIngredient, setSelectedIngredient] = useState<{
    id: number;
    amount?: number;
  } | null>(null);

  const { createFooterButton } = usePdpFooter({
    onAdd: onClose,
    onRemove: onClose,
  });

  const onDismiss = () => {
    setSelectedIngredient(null);
    onClose();
  };

  const onBackClick = () => {
    setSelectedIngredient(null);
  };

  const props: PDPModalProps | undefined = selectedIngredient?.id
    ? {
        id: selectedIngredient.id,
        onDismiss,
        onBackClick,
        stacked: true,
        createFooterButton,
      }
    : undefined;

  return {
    openPdp: setSelectedIngredient,
    props,
  };
}
